import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "FrontPage",
    component: () =>
      import(/* webpackChunkName: "visits" */ "../views/FrontPage.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
